import { AgentChatbotWidget } from '@libs/agent-chat';
import { useReleaseFlag } from '@libs/contexts';
import { GlobalArea } from '@libs/templates/global-area';
import { Outlet } from 'react-router';
import { useCompany } from '../context/CompanyContext';
import { HeaderLabels } from './HeaderLabels';

export function AgentChatbotConnector() {
  const { company } = useCompany();
  const { isEnabled, isLoading } = useReleaseFlag('release.agent.chat_panel_v1');

  if (isLoading || !isEnabled) {
    return null;
  }

  return <AgentChatbotWidget companyCode={company.companyCode} />;
}

/** 既存UI（v1）の画面のコンテナ。provider 群は親の {@link FaContainer} が持つ。 */
function ContainerWithContext() {
  return (
    <>
      <GlobalArea homePath="/fa/main-menu">
        <HeaderLabels />
      </GlobalArea>
      <Outlet />
      <AgentChatbotConnector />
    </>
  );
}

export { ContainerWithContext };
